module.exports = "<div class=\"loans-detail-statement-income\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <p ng-repeat=\"paragraph in $ctrl.loan.detail.statementIncome\">\n    {{ paragraph | translate }}\n  </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/loans.module/features/loansDetail/loansDetailStatementIncome/loansDetailStatementIncome.html
// module id = 1878
// module chunks = 0